import Editor, { EditorProps, loader } from "@monaco-editor/react";
import styles from "./CodeEditor.module.css";
import { beforeMount } from "./beforeMount";
import { classNames } from "@/lib/utils";

loader.config({
  paths: { vs: "/vs" },
  // This seems to still result in requests to http://localhost:3000/vs/base/common/worker/simpleWorker.nls.js
  // Not sure why. (We'd expect requests to http://localhost:3000/monaco-editor/base/common/worker/simpleWorker.nls.js)
  // Results in errors in console but does not seem to affect functionality.
});

interface CodeEditorProps extends EditorProps {
  loading?: boolean;
  loadingText?: string;
}

const CodeEditor = ({ loading = false, loadingText = "Loading...", ...props }: CodeEditorProps) => {
  return (
    <div className="h-full w-full">
      <Editor
        className={classNames(styles.editor, loading && "pointer-events-none opacity-50 shadow-none")}
        theme="llama"
        defaultLanguage={props.defaultLanguage || "python"}
        {...props}
        beforeMount={beforeMount}
        options={{
          ...CODE_EDITOR_DEFAULT_OPTIONS,
          ...props.options,
        }}
        loading={
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="animate-pulse text-text-base-1">{loadingText}</div>
          </div>
        }
      />
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="animate-pulse text-text-base-1">{loadingText}</div>
        </div>
      )}
    </div>
  );
};

export default CodeEditor;

export const CODE_EDITOR_DEFAULT_OPTIONS = {
  minimap: { enabled: false },
  lineNumbers: "on",
  scrollBeyondLastLine: false,
  folding: false,
  lineNumbersMinChars: 3,
  automaticLayout: true,
  // Removes the horizontal lines around the cursor
  renderLineHighlight: "none",
  // Removes the vertical line on the right hand side
  overviewRulerLanes: 0,
  scrollbar: {
    useShadows: true,
    verticalScrollbarSize: 8,
    horizontalScrollbarSize: 8,
  },
} satisfies EditorProps["options"];
